import { render, staticRenderFns } from "./PhoneNumberPublishing.vue?vue&type=template&id=12d28d64&scoped=true&"
import script from "./PhoneNumberPublishing.ts?vue&type=script&lang=ts&"
export * from "./PhoneNumberPublishing.ts?vue&type=script&lang=ts&"
import style0 from "./PhoneNumberPublishing.vue?vue&type=style&index=0&id=12d28d64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d28d64",
  null
  
)

export default component.exports